<template>
  <v-dialog
    id="confirm_box"
    v-model="show"
    :width="`${width}px`">
    <div class="dialog-container">
      <template v-if="!isNewConfirm">
        <h2>{{ title }}</h2>
        <p>
          {{ message }}
        </p>
      </template>
      <template v-else>
        <div
          v-if="title"
          class="header flex">
          <p>{{ title }}</p>
          <font-awesome-icon
            icon="times"
            class="close"
            @click="show = false"></font-awesome-icon>
        </div>
        <p
          class="tips"
          :class="{'color-red':isRed}"
          v-html="message" >
        </p>
        <p
          v-if="message2"
          class="tips mg-t-10"
          v-html="message2">
        </p>
      </template>
      <div class="flex-sb dialog-footer">
        <div>
          <v-button
            v-if="cancelBtn"
            :gray="isNewConfirm"
            @click="onCancel">{{ cancelBtn }}</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            :red="isNewConfirm&&!message2&&!isGreen"
            :all-red="isBtnRed"
            :green="isNewConfirm&&message2||isGreen"
            @click="onConfirm">{{ confirmBtn }}</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmBox',
  data() {
    return {
      show: false,
      title: '',
      message: '',
      message2:'',
      cancelBtn: 'Cancel',
      confirmBtn: 'Yes',
      promiseStatus: null,
      width:328,
      isNewConfirm:false,
      isGreen:false,
      isRed:false,
      isBtnRed:false,
      id:'confirm_box'
    }
  },
  methods: {
    confirm() {
      return new Promise((resolve, reject) => {
        this.promiseStatus = {
          resolve,
          reject
        }
      })
    },
    onCancel() {
      this.show = false
      this.promiseStatus.reject()
    },
    onConfirm() {
      this.show = false
      this.promiseStatus.resolve()
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      color: #616266;
      h2 {
          font-size: 24px;
          line-height: 30px;
      }
      p {
        padding-bottom: 10px;
        font-size: 16px;
        line-height: 18px;
      }
      .dialog-footer {
          margin-top: 15px;
      }
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    margin: -15px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .tips{
    color: #24292E;
    margin-top: 35px;
    font-weight: 400;
    font-size: 14px;
    &.mg-t-10{
      margin-top: 10px;
    }
    &.color-red{
      color: #CB2431!important;
    }
  }
    }
</style>
